function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.0527344,
  y: 407.375,
  width: 534.67,
  height: 525.079,
  fill: "url(#mission_can_right0)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M452.993 376.961C452.967 422.665 439.13 467.294 413.295 504.995C387.461 542.696 350.836 571.71 308.223 588.231V603.461H226.523C101.443 603.461 0.0529078 502.041 0.0529078 376.971C0.0160667 347.219 5.84845 317.751 17.2161 290.255C28.5837 262.76 45.2633 237.777 66.2998 216.737C87.3363 195.696 112.317 179.012 139.81 167.64C167.303 156.267 196.77 150.43 226.523 150.461H308.223V165.661C350.875 182.134 387.537 211.14 413.379 248.858C439.222 286.577 453.033 331.239 452.993 376.961Z",
  fill: "url(#mission_can_right1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M107.793 284.191C110.233 323.291 107.513 354.081 103.343 376.961C97.1729 410.881 87.8429 427.441 87.5229 427.961C87.5229 427.961 53.9529 416.181 37.0529 376.961C24.5429 348.041 21.0529 304.201 46.8129 239.201C75.9308 201.2 116.331 173.392 162.223 159.761C136.393 185.971 109.223 224.581 107.613 271.821C107.473 275.881 107.533 280.005 107.793 284.191Z",
  fill: "#526293"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M534.723 376.961C534.676 432.563 514.181 486.206 477.142 527.675C440.102 569.143 389.105 595.541 333.861 601.841C278.617 608.141 222.985 593.904 177.56 561.84C132.134 529.776 100.088 482.125 87.523 427.961C75.3345 375.178 82.4582 319.775 107.603 271.791C131.123 226.932 169 191.249 215.182 170.446C261.364 149.642 313.187 144.918 362.369 157.029C411.552 169.139 455.256 197.385 486.499 237.252C517.742 277.12 534.721 326.31 534.723 376.961Z",
  fill: "url(#mission_can_right2)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M87.523 428.001C75.3695 375.216 82.4916 319.825 107.603 271.831L308.223 376.971L87.523 428.001Z",
  fill: "#485982"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  d: "M534.723 376.961H0.0528957C0.0173707 347.21 5.85073 317.743 17.219 290.249C28.5872 262.754 45.267 237.772 66.3034 216.733C87.3397 195.694 112.319 179.011 139.812 167.639C167.305 156.267 196.771 150.43 226.523 150.461H303.963C334.061 149.906 363.968 155.354 391.937 166.487C419.906 177.619 445.376 194.214 466.86 215.301C488.343 236.388 505.409 261.544 517.061 289.301C528.713 317.058 534.717 346.858 534.723 376.961Z",
  fill: "#7491C4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M492.723 0.178467H123.723V376.971H492.723V0.178467Z",
  fill: "url(#mission_can_right3)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M492.723 376.961C492.723 478.851 410.123 561.461 308.223 561.461C206.323 561.461 123.723 478.851 123.723 376.961C123.723 275.061 206.323 192.461 308.223 192.461C410.123 192.461 492.713 275.061 492.723 376.961Z",
  fill: "#3C4466"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M492.723 376.961H123.723C123.723 275.061 206.323 192.461 308.223 192.461C410.123 192.461 492.713 275.061 492.723 376.961Z",
  fill: "#7491C4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M308.223 551.981C404.884 551.981 483.243 473.622 483.243 376.961C483.243 280.301 404.884 201.941 308.223 201.941C211.562 201.941 133.203 280.301 133.203 376.961C133.203 473.622 211.562 551.981 308.223 551.981Z",
  fill: "url(#mission_can_right4)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M308.223 532.881C394.335 532.881 464.143 463.073 464.143 376.961C464.143 290.849 394.335 221.041 308.223 221.041C222.111 221.041 152.303 290.849 152.303 376.961C152.303 463.073 222.111 532.881 308.223 532.881Z",
  fill: "url(#mission_can_right5)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M302.182 477.148L311.715 486.792C330.453 505.747 361.009 505.923 379.964 487.185L417.62 449.96C436.575 431.222 436.751 400.666 418.013 381.711L408.48 372.068C389.742 353.113 359.186 352.937 340.231 371.675L302.575 408.9C283.62 427.637 283.444 458.193 302.182 477.148Z",
  stroke: "#120E26",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M349.053 362.951C348.714 358.914 347.079 355.094 344.393 352.061L266.393 263.641C264.692 261.716 262.617 260.157 260.294 259.061C257.97 257.965 255.448 257.354 252.88 257.266C250.313 257.178 247.754 257.615 245.361 258.549C242.968 259.484 240.791 260.897 238.963 262.701L194.793 306.371C192.967 308.178 191.528 310.339 190.566 312.721C189.603 315.103 189.137 317.656 189.195 320.225C189.253 322.793 189.834 325.323 190.903 327.659C191.973 329.995 193.507 332.089 195.413 333.811L227.683 362.951L282.933 412.841C286.51 416.075 291.189 417.816 296.01 417.706C300.831 417.597 305.427 415.645 308.853 412.251L343.523 377.981C345.493 376.037 347.01 373.681 347.965 371.084C348.921 368.486 349.292 365.709 349.053 362.951ZM211.763 326.401C210.07 324.689 209.126 322.375 209.139 319.967C209.152 317.559 210.121 315.255 211.833 313.561L249.053 276.761C250.766 275.069 253.081 274.127 255.489 274.142C257.897 274.157 260.201 275.128 261.893 276.841L283.343 298.541C285.036 300.253 285.98 302.568 285.967 304.976C285.954 307.384 284.985 309.688 283.273 311.381L246.053 348.181C244.341 349.875 242.026 350.818 239.618 350.805C237.21 350.792 234.906 349.823 233.213 348.111L211.763 326.401ZM322.473 369.401L300.473 391.121C297.149 394.403 292.658 396.231 287.987 396.203C283.316 396.175 278.847 394.293 275.563 390.971L266.103 381.401C263.755 379.022 262.132 376.024 261.423 372.757C260.715 369.49 260.951 366.089 262.103 362.951C262.992 360.519 264.413 358.315 266.263 356.501L288.263 334.781C291.585 331.498 296.076 329.668 300.747 329.695C305.418 329.721 309.887 331.601 313.173 334.921L322.633 344.501C324.259 346.145 325.546 348.093 326.42 350.234C327.293 352.376 327.736 354.668 327.723 356.98C327.71 359.293 327.241 361.58 326.344 363.711C325.446 365.843 324.138 367.776 322.493 369.401H322.473Z",
  fill: "#223B72"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M313.899 407.254C294.944 425.991 294.766 456.546 313.502 475.499C332.238 494.452 362.792 494.626 381.747 475.888L406.304 451.613C425.259 432.875 425.436 402.321 406.7 383.368C387.965 364.415 357.41 364.24 338.455 382.978L313.899 407.254Z",
  fill: "#120E26"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M349.113 246.141H189.163V417.711H349.113V246.141Z",
  fill: "url(#mission_can_right6)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M349.053 362.951C348.714 358.914 347.079 355.094 344.393 352.061L266.393 263.641C264.692 261.716 262.617 260.157 260.294 259.061C257.97 257.965 255.448 257.354 252.88 257.266C250.313 257.178 247.754 257.615 245.361 258.549C242.968 259.484 240.791 260.897 238.963 262.701L194.793 306.371C192.967 308.178 191.528 310.339 190.566 312.721C189.603 315.103 189.137 317.656 189.195 320.225C189.253 322.793 189.834 325.323 190.903 327.659C191.973 329.995 193.507 332.089 195.413 333.811L227.683 362.951H262.143C263.032 360.519 264.453 358.315 266.303 356.501L288.303 334.781C291.625 331.498 296.116 329.668 300.787 329.695C305.458 329.721 309.927 331.601 313.213 334.921L322.673 344.501C325.022 346.88 326.646 349.878 327.354 353.145C328.062 356.412 327.826 359.814 326.673 362.951H349.053ZM283.283 311.381L246.053 348.181C244.341 349.875 242.026 350.818 239.618 350.805C237.21 350.792 234.906 349.823 233.213 348.111L211.753 326.401C210.06 324.689 209.116 322.375 209.129 319.967C209.142 317.559 210.111 315.255 211.823 313.561L249.053 276.761C250.766 275.069 253.081 274.127 255.489 274.142C257.897 274.157 260.201 275.128 261.893 276.841L283.343 298.541C285.037 300.252 285.983 302.566 285.972 304.974C285.961 307.382 284.993 309.687 283.283 311.381Z",
  fill: "#7491C4"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_right0",
  x1: 267.388,
  y1: 407.375,
  x2: 267.388,
  y2: 932.455,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.294748,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.963974,
  stopColor: "#120E26",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_right1",
  x1: 113.273,
  y1: 573.121,
  x2: 345.013,
  y2: 171.731,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3D307F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.223958,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#24335B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#22396C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_right2",
  x1: 81.713,
  y1: 376.961,
  x2: 531.623,
  y2: 376.961,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#24335B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#22396C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_right3",
  x1: 308.553,
  y1: 12.1076,
  x2: 306.67,
  y2: 372.888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7491C4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#7491C4",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#7491C4",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#7491C4",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#7491C4",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#7491C4",
  stopOpacity: 0.67
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#7491C4",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_right4",
  x1: 483.243,
  y1: 376.961,
  x2: 133.193,
  y2: 376.961,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#232E55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#1F224C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1542"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_right5",
  x1: 397.768,
  y1: 510.708,
  x2: 224.247,
  y2: 251.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#120E26"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#1B203F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#222D52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#243258"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#233868"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#223A6F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#223B72"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mission_can_right6",
  x1: 269.383,
  y1: 251.751,
  x2: 268.873,
  y2: 415.681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7491C4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#7491C4",
  stopOpacity: 0.24
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#7491C4",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#7491C4",
  stopOpacity: 0.64
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#7491C4",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7491C4",
  stopOpacity: 0.53
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7491C4",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#7491C4",
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#7491C4",
  stopOpacity: 0.04
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7491C4",
  stopOpacity: 0
})));

function SvgCanRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 535 933",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _ref2), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanRight);
export default __webpack_public_path__ + "static/media/can-right.61196756.svg";
export { ForwardRef as ReactComponent };